/*
 * Revista (artículo), 4-oct-2026.
 * - Barra de lectura arriba.
 * - Índice «En este artículo» armado con los H2 del cuerpo (y las
 *   preguntas frecuentes), con la sección visible resaltada.
 * - Tablas envueltas para desplazarse de lado en el celular.
 * - Botón «Copiar el enlace».
 * - Multimedia (5-oct-2026): recorrido con puntos, galería con visor y
 *   video de YouTube que carga al tocarlo.
 * En escritorio desplaza .page-wrapper y no window: todo se calcula con
 * getBoundingClientRect y se escucha el scroll en fase de captura.
 */
(function () {
  var art = document.querySelector('[data-rgt-rv-art]');
  if (!art) return;
  var cuerpo = art.querySelector('[data-rgt-rv-cuerpo]');
  var escritorio = window.matchMedia('(min-width: 1340px)'); // índice al costado (rgt-revista-estilos)

  /* Tablas desplazables */
  if (cuerpo) {
    cuerpo.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement.classList.contains('rgt-rv-tabla')) return;
      var caja = document.createElement('div');
      caja.className = 'rgt-rv-tabla';
      t.parentNode.insertBefore(caja, t);
      caja.appendChild(t);
    });
    /* Enlaces a otros sitios en pestaña nueva */
    cuerpo.querySelectorAll('a[href^="http"]').forEach(function (a) {
      if (a.hostname !== location.hostname) { a.target = '_blank'; a.rel = 'noopener'; }
    });
  }

  /* Índice */
  var indice = art.querySelector('[data-rgt-rv-indice]');
  var lista = indice ? indice.querySelector('ol') : null;
  var titulos = [];
  if (lista && cuerpo) {
    var usados = {};
    var hs = Array.prototype.slice.call(cuerpo.querySelectorAll('h2'));
    var faq = art.querySelector('#rgt-rv-faq');
    if (faq) hs.push(faq);
    hs.forEach(function (h) {
      if (!h.id) {
        var base = (h.textContent || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'seccion';
        var id = base, i = 2;
        while (usados[id] || document.getElementById(id)) { id = base + '-' + i++; }
        h.id = id;
      }
      usados[h.id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
        if (!escritorio.matches) indice.open = false;
      });
      li.appendChild(a);
      lista.appendChild(li);
      titulos.push({ h: h, a: a });
    });

    var abrir = function () { if (escritorio.matches) indice.open = true; };
    abrir();
    if (escritorio.addEventListener) escritorio.addEventListener('change', abrir);

  }

  /* Sección visible en el índice: el último título que ya pasó el 30 %
     superior de la pantalla. */
  var activo = null;
  var actualizarIndice = function () {
    if (!titulos.length) return;
    var actual = titulos[0].a, tope = window.innerHeight * 0.3;
    titulos.forEach(function (t) { if (t.h.getBoundingClientRect().top <= tope) actual = t.a; });
    if (activo === actual) return;
    if (activo) activo.classList.remove('is-activo');
    activo = actual;
    activo.classList.add('is-activo');
  };

  /* Barra de lectura */
  var barra = document.querySelector('[data-rgt-rv-barra]');
  if (barra) {
    var pendiente = false;
    var pintar = function () {
      pendiente = false;
      var r = (cuerpo || art).getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var hecho = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      barra.style.transform = 'scaleX(' + hecho.toFixed(4) + ')';
      actualizarIndice();
    };
    var pedir = function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } };
    document.addEventListener('scroll', pedir, { passive: true, capture: true });
    window.addEventListener('resize', pedir, { passive: true });
    pintar();
  }

  /* ── Multimedia (5-oct-2026) ── */

  /* Recorrido: tocar un número (en la foto o en la lista) abre su
     explicación y resalta el punto. Sin JS se ven todas las explicaciones. */
  art.querySelectorAll('[data-rgt-rv-recorrido]').forEach(function (fig) {
    var puntos = Array.prototype.slice.call(fig.querySelectorAll('.rgt-rv-punto'));
    var items = Array.prototype.slice.call(fig.querySelectorAll('.rgt-rv-recorrido__lista li'));
    if (!puntos.length || puntos.length !== items.length) return;
    fig.classList.add('is-js');
    var lado = window.matchMedia('(min-width: 750px)');
    var activar = function (i, desdeFoto) {
      items.forEach(function (li, j) {
        var on = j === i;
        li.classList.toggle('is-activo', on);
        var b = li.querySelector('button');
        if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      puntos.forEach(function (p, j) {
        p.classList.toggle('is-activo', j === i);
        p.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      if (desdeFoto && !lado.matches) {
        var r = items[i].getBoundingClientRect();
        if (r.bottom > window.innerHeight || r.top < 0) items[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    };
    puntos.forEach(function (p, i) { p.addEventListener('click', function () { activar(i, true); }); });
    items.forEach(function (li, i) {
      var b = li.querySelector('button');
      if (b) b.addEventListener('click', function () { activar(i, false); });
    });
    activar(0, false);
  });

  /* Galería: visor a pantalla completa con flechas, teclado y deslizar. */
  var visor = null, vImg, vPie, vCuenta, vFotos = [], vI = 0, vOrigen = null;
  var icono = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
  var mostrar = function (i) {
    vI = (i + vFotos.length) % vFotos.length;
    var f = vFotos[vI];
    vImg.src = f.src;
    vImg.alt = f.alt;
    vPie.textContent = f.pie || f.alt || '';
    vCuenta.textContent = (vI + 1) + ' / ' + vFotos.length;
  };
  var cerrar = function () { if (visor && visor.open) visor.close(); };
  var crearVisor = function () {
    visor = document.createElement('dialog');
    visor.className = 'rgt-rv-visor';
    visor.tabIndex = -1;
    visor.setAttribute('aria-label', 'Galería de fotos');
    visor.innerHTML =
      '<p class="rgt-rv-visor__cuenta" aria-live="polite"></p>' +
      '<div class="rgt-rv-visor__img"><img alt=""></div>' +
      '<p class="rgt-rv-visor__pie"></p>' +
      '<button type="button" class="rgt-rv-visor__nav rgt-rv-visor__nav--ant" aria-label="Foto anterior">' + icono('M15 6l-6 6 6 6') + '</button>' +
      '<button type="button" class="rgt-rv-visor__nav rgt-rv-visor__nav--sig" aria-label="Foto siguiente">' + icono('M9 6l6 6-6 6') + '</button>' +
      '<button type="button" class="rgt-rv-visor__cerrar" aria-label="Cerrar">' + icono('M6 6l12 12M18 6L6 18') + '</button>';
    document.body.appendChild(visor);
    vImg = visor.querySelector('img');
    vPie = visor.querySelector('.rgt-rv-visor__pie');
    vCuenta = visor.querySelector('.rgt-rv-visor__cuenta');
    visor.querySelector('.rgt-rv-visor__cerrar').addEventListener('click', cerrar);
    visor.querySelector('.rgt-rv-visor__nav--ant').addEventListener('click', function () { mostrar(vI - 1); });
    visor.querySelector('.rgt-rv-visor__nav--sig').addEventListener('click', function () { mostrar(vI + 1); });
    visor.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); mostrar(vI - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); mostrar(vI + 1); }
    });
    /* Tocar fuera de la foto cierra. La imagen llena su caja con
       object-fit: contain, así que se calcula el rectángulo pintado. */
    visor.addEventListener('click', function (e) {
      if (e.target === visor || e.target.classList.contains('rgt-rv-visor__img')) { cerrar(); return; }
      if (e.target === vImg && vImg.naturalWidth) {
        var r = vImg.getBoundingClientRect();
        var esc = Math.min(r.width / vImg.naturalWidth, r.height / vImg.naturalHeight);
        var w = vImg.naturalWidth * esc, h = vImg.naturalHeight * esc;
        var x0 = r.left + (r.width - w) / 2, y0 = r.top + (r.height - h) / 2;
        if (e.clientX < x0 || e.clientX > x0 + w || e.clientY < y0 || e.clientY > y0 + h) cerrar();
      }
    });
    var x0 = null;
    visor.addEventListener('touchstart', function (e) { x0 = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    visor.addEventListener('touchend', function (e) {
      if (x0 === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 50) mostrar(vI + (dx < 0 ? 1 : -1));
    });
    visor.addEventListener('close', function () {
      document.documentElement.classList.remove('rgt-rv-sin-scroll');
      if (vOrigen) vOrigen.focus();
    });
  };
  art.querySelectorAll('[data-rgt-rv-galeria]').forEach(function (g) {
    var botones = Array.prototype.slice.call(g.querySelectorAll('button[data-src]'));
    var fotos = botones.map(function (b) {
      var img = b.querySelector('img');
      return { src: b.getAttribute('data-src'), alt: img ? img.alt : '', pie: b.getAttribute('data-pie') };
    });
    botones.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (!visor) crearVisor();
        if (typeof visor.showModal !== 'function') { window.open(fotos[i].src, '_blank', 'noopener'); return; }
        vFotos = fotos;
        vOrigen = b;
        mostrar(i);
        visor.showModal();
        visor.focus(); /* el foco va al visor, no al botón «anterior» */
        document.documentElement.classList.add('rgt-rv-sin-scroll');
      });
    });
  });

  /* Relojes de la tienda: los filtros por línea muestran solo los de ese grupo. */
  art.querySelectorAll('[data-rgt-rv-relojes]').forEach(function (fig) {
    var botones = Array.prototype.slice.call(fig.querySelectorAll('.rgt-rv-filtros button'));
    var items = Array.prototype.slice.call(fig.querySelectorAll('.rgt-rv-relojes-mm__rejilla > li'));
    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-grupo');
        botones.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        items.forEach(function (li) { li.hidden = !!g && li.getAttribute('data-grupo') !== g; });
      });
    });
  });

  /* Prueba tu grabado: el texto se ve en la tapa mientras se escribe, con
     contador, y el botón lleva ese texto al mensaje de WhatsApp. */
  art.querySelectorAll('[data-rgt-rv-grabado]').forEach(function (fig) {
    var input = fig.querySelector('[data-rgt-rv-grabado-input]');
    var texto = fig.querySelector('[data-rgt-rv-grabado-texto]');
    var cuenta = fig.querySelector('[data-rgt-rv-grabado-cuenta]');
    var wa = fig.querySelector('[data-rgt-rv-grabado-wa]');
    if (!input || !texto) return;
    var max = parseInt(fig.getAttribute('data-max'), 10) || 25;
    var ejemplo = texto.getAttribute('data-ejemplo') || '';
    var base = wa ? wa.getAttribute('href').split('?')[0] : '';
    var pintar = function () {
      var v = input.value.slice(0, max);
      var t = v.trim() ? v : ejemplo;
      /* guion que no corta la línea: una fecha «24-12-26» no se parte */
      texto.textContent = t.replace(/-/g, '\u2011');
      texto.classList.toggle('is-ejemplo', !v.trim());
      texto.classList.toggle('is-medio', t.length > 12 && t.length <= 18);
      texto.classList.toggle('is-largo', t.length > 18);
      if (cuenta) {
        cuenta.textContent = v.length;
        cuenta.parentNode.classList.toggle('is-lleno', v.length >= max);
      }
      if (wa) {
        var msj = v.trim()
          ? 'Hola, quiero un reloj con este grabado en la tapa: «' + v.trim() + '»'
          : 'Hola, quiero un reloj con grabado en la tapa.';
        wa.setAttribute('href', base + '?text=' + encodeURIComponent(msj));
      }
    };
    input.addEventListener('input', pintar);
    pintar();
  });

  /* Video: el reproductor de YouTube carga solo al tocarlo (sin cookies). */
  art.querySelectorAll('[data-rgt-rv-video]').forEach(function (fig) {
    var b = fig.querySelector('.rgt-rv-video__play');
    var id = fig.getAttribute('data-id') || '';
    if (!b || !/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    b.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0';
      f.title = fig.getAttribute('data-titulo') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.setAttribute('allowfullscreen', '');
      b.replaceWith(f);
    });
  });

  /* Copiar el enlace */
  art.querySelectorAll('[data-rgt-rv-copiar]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = b.getAttribute('data-rgt-rv-copiar');
      var listo = function () {
        b.setAttribute('data-copiado', 'Enlace copiado');
        setTimeout(function () { b.removeAttribute('data-copiado'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(listo, function () { window.prompt('Copia el enlace:', url); });
      } else {
        window.prompt('Copia el enlace:', url);
      }
    });
  });
})();
